import React, { SetStateAction, useState, Dispatch, Fragment } from 'react';
import { IconButton, Typography, CssBaseline, Button, Input } from "@material-ui/core";
import { makeStyles, createStyles, withStyles, WithStyles } from '@material-ui/core/styles';

import axios from 'axios'
import { useHistory } from "react-router-dom";

import { useSnackbar } from 'notistack';
import ToastStr from '../request/toastStr';

import { COLORS } from './Theme'
import { SIcon } from './Icon';

import { member as v_member, basic, Values, SPLASH_TIME, SNACKBAR_TIME } from '../request/values';

import SplashFoundation from './SplashFoundation';
import useFixedButtonStyles from "./commonStyles/headerEmpty/useFixedButtonStyles";

const SERVER = basic.server;


const useStyles = makeStyles((theme) => ({
    paper: {
        // marginTop: theme.spacing(8),
        // marginTop: '15vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    title: {
        // width: '80%',
        alignItems: 'left'
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        // width: '80%', // Fix IE 11 issue.
        // marginTop: theme.spacing(1),
    },
    desc: {
        fontFamily: 'NanumR',
        fontSize: 12,
        textAlign: 'center'
    },
    subTitle: {
        color: `${COLORS.WATER_BLUE}`,
        fontSize: 26,
        fontFamily: 'NanumB',
        marginTop: '3vh',
        marginBottom: '1vh'
    },
    button: {
        height: 60,
        margin: theme.spacing(3, 0, 2),
        borderRadius: '27px',
        boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        border: 'solid 0.5px #cfd4d9',
        // backgroundColor: `${COLORS.WHITE}`,
        // color: `${COLORS.WATER_BLUE}`,
    },
    logoSection: {
        // width: '86vw',
        // textAlign: 'center'
        display: 'flex',
        justifyContent: 'center',
        flex: 1,
        alignItems: 'flex-end',
        marginTop: '30vh',
        [theme.breakpoints.up("md")]: {
          marginTop: '20vh',
        },
    },
    input: { 
      ...theme.typography.subtitle1,
      fontFamily: 'NanumR',  
    }
}));


const CompanyFoundation: React.FC<any> = props => {
    const classes = useStyles();
    const fixedButtonClasses = useFixedButtonStyles();

    const [name, setName] = useState<string>('');
    const [splash, setSplash] = useState<boolean>(false);

    let history = useHistory();
    const state: any = history.location.state
    const type = state.type;
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    // const { member, setMember } = useMember();
    const { member, setMember } = props

    const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.target;
        setName(value)
    }

    const action = (key: any) => (
        <Fragment>
            <Button onClick={() => { closeSnackbar(key) }}>
                Close
            </Button>
        </Fragment>
    );

    const handleButton = () => {

        if (name.length != 0) {

            let url = new URL(SERVER + v_member.member + v_member.company_exist);
            let params = { 'company_name': name, 'class_code': member.classCode, 'action': 'join' }
            url.search = new URLSearchParams(params).toString();

            axios({
                method: 'GET',
                withCredentials: true,
                url: url.toString(),
            }).then((res) => {return res.data
            }).then((data: any) => {
                    console.log(data)
                    if (data.code == Values.FAIL_CODE) {
                        throw { code: Values.FAIL_CODE }
                    }
                    else if(data.code == Values.EXCEPTION_CODE){
                        throw { code: Values.EXCEPTION_CODE }
                    }
                }).then(() => {
                    return axios({
                        method: 'POST',
                        data: {
                            classCode: member.classCode,
                            companyName: name,
                            name: member.name,
                            email: member.id,
                            type: type,
                        },
                        withCredentials: true,
                        url: SERVER + v_member.member + v_member.company_foundation,
                    }).then((res) => res.data)
                        .then(async (data: any) => {
                            console.log(data)
                            console.log(data.companies.companyType)
                            setSplash((prev) => true);
                            setTimeout(() => {
                                setMember(Object.assign({}, member, { companyNum: data.companies.companyNum, companyType: type}))
                                history.push({
                                    pathname: '/',
                                });                                
                            }, SPLASH_TIME);
                            enqueueSnackbar(ToastStr.COMPANY_FOUNDATION_SUCCESS, { variant: "success", autoHideDuration: SNACKBAR_TIME, translate: "no" })
                        })
                }).catch((err) => {
                    console.log("error?", err.code)
                    if(err.code == Values.FAIL_CODE){
                        enqueueSnackbar(ToastStr.COMPANY_EXIST_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME, translate: "no" })
                    } else{
                        enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, { variant: "error", autoHideDuration: SNACKBAR_TIME, translate: "no" })
                    }
                })
        } else {
            enqueueSnackbar(ToastStr.COMPANY_NAME_CHECK_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME, translate: "no" })
        }
    }

    const postCompanyFoundation = () => {

        axios({
            method: 'POST',
            data: {
                classCode: member.classCode,
                companyName: name,
                name: member.name,
                email: member.id,
            },
            withCredentials: true,
            url: SERVER + v_member.member + v_member.company_foundation,
        }).then((res) => res.data)
            .then((data: any) => {
                console.log(data)

                if (data.code == Values.SUCCESS_CODE) {
                    console.log(data.companies.companyNum)
                    console.log(Object.assign(member, { companyNum: data.companies.companyNum }))

                    setMember(() => Object.assign(member, { companyNum: data.companies.companyNum }))
                    history.push({
                        pathname: '../',
                    });

                    enqueueSnackbar(ToastStr.COMPANY_FOUNDATION_SUCCESS, { variant: "success", autoHideDuration: SNACKBAR_TIME, translate: "no" })
                } else if (data.code == Values.FAIL_CODE) {
                    enqueueSnackbar(ToastStr.COMPANY_EXIST_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME, translate: "no" })
                }
            })

    }

    if (splash) return <SplashFoundation companyName={name} />

    if(type == 'M') {
        return (
            <div>
                <div className={fixedButtonClasses.fixedButton}>
                <IconButton onClick={() => history.goBack()}>
                    <SIcon type='Back' />
                </IconButton>
                </div>
                <div className={classes.paper}>
                    <div className={classes.title}>
                        <img src="/images/building.png" />
                        <Typography variant="h1" className={classes.desc} style={{ fontFamily: 'NanumR', }}>
                            설립할 제조기업의 이름을 알려주세요.
                        </Typography>
                    </div>

                    <div className={classes.form} >
                        <Typography className={classes.subTitle}>
                            새싹기업 이름
                        </Typography>
                        <Input
                            margin="none"
                            fullWidth
                            value={name}
                            onChange={valueChangeHandler}
                            // inputProps={{ classeName: classes.input }}
                            classes={{
                              input: classes.input,   
                            }}
                        />
                        <Button
                            fullWidth
                            className={classes.button}
                            onClick={handleButton}
                        >
                            <Typography variant="h3" style={{ color: `${COLORS.WATER_BLUE}`, fontFamily: 'NanumB' }}>
                                새싹기업 설립하기
                            </Typography>
                        </Button>
                    </div>
                </div>
                <div className={classes.logoSection}>
                    <SIcon type="P" />
                </div>

                {/* <Box mt={8}>
        <Copyright />
      </Box> */}
            </div>

        );
    }
    else if(type == 'S') {
        return (
            <div>
                <div className={fixedButtonClasses.fixedButton}>
                <IconButton onClick={() => history.goBack()}>
                    <SIcon type='Back' />
                </IconButton>
                </div>

                <div className={classes.paper}>
                    <div className={classes.title}>
                        <img src="/images/building.png" />
                        <Typography variant="h1" className={classes.desc} style={{ fontFamily: 'NanumR', }}>
                            설립할 서비스기업의 이름을 알려주세요.{type}
                        </Typography>
                    </div>

                    <div className={classes.form} >
                        <Typography className={classes.subTitle}>
                            새싹기업 이름
                        </Typography>
                        <Input
                            margin="none"
                            fullWidth
                            value={name}
                            onChange={valueChangeHandler}
                            inputProps={{ className: classes.input }}
                        />
                        <Button
                            fullWidth
                            className={classes.button}
                            onClick={handleButton}
                        >
                            <Typography variant="h3" style={{ color: `${COLORS.WATER_BLUE}`, fontFamily: 'NanumB' }}>
                                새싹기업 설립하기
                            </Typography>
                        </Button>
                    </div>
                </div>
                <div className={classes.logoSection}>
                    <SIcon type="P" />
                </div>

                {/* <Box mt={8}>
        <Copyright />
      </Box> */}
            </div>

        );
    }
    else {
        return (
            <div>
               <div className={fixedButtonClasses.fixedButton}>
                <IconButton onClick={() => history.goBack()}>
                    <SIcon type='Back' />
                </IconButton>
                </div>

                <div className={classes.paper}>
                    <div className={classes.title}>
                        <img src="/images/building.png" />
                        <Typography variant="h1" className={classes.desc} style={{ fontFamily: 'NanumR', }}>
                            설립할 유통기업의 이름을 알려주세요.{type}
                        </Typography>
                    </div>

                    <div className={classes.form} >
                        <Typography className={classes.subTitle}>
                            새싹기업 이름
                        </Typography>
                        <Input
                            margin="none"
                            fullWidth
                            value={name}
                            onChange={valueChangeHandler}
                            inputProps={{ classes: { input: classes.input } }}
                        />
                        <Button
                            fullWidth
                            className={classes.button}
                            onClick={handleButton}
                        >
                            <Typography variant="h3" style={{ color: `${COLORS.WATER_BLUE}`, fontFamily: 'NanumB' }}>
                                새싹기업 설립하기
                            </Typography>
                        </Button>
                    </div>
                </div>
                <div className={classes.logoSection}>
                    <SIcon type="P" />
                </div>

                {/* <Box mt={8}>
        <Copyright />
      </Box> */}
            </div>

        );
    }
}


export default CompanyFoundation;